import React from 'react';
import { TestIssueService } from '@/api/testIssue';
import { Loading } from '@/components/Loading';
import { Section } from '@/components/Section';
import { useParams } from 'react-router-dom';
import { TestIssueDetail } from '@/components/testIssue/TestIssueDetail';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { useBackNavigate } from '@/utils/hooks/useBackNavigate';

type DetailTestIssueProps = {
  id?: string;
  isPublic?: boolean;
};
export const DetailTestIssue: React.FC<DetailTestIssueProps> = ({ id, isPublic }) => {
  const { testIssueId } = useParams();
  const backNavigate = useBackNavigate(isPublic);

  const { data: testIssueData, isFetching: isFetchingLoading } =
    TestIssueService.useGet(testIssueId! ?? id);

  if (isFetchingLoading) {
    return (
      <Section>
        <Loading />
      </Section>
    );
  }

  return (
    <div>
      <Section
        title={`${testIssueData?.code_issue ?? ''} - ${testIssueData?.title}`}
      >
        <TestIssueDetail testIssueData={testIssueData!} isPublic={isPublic} />
      </Section>

      <div className="p-3 mx-4 mt-0 bg-white rounded-md shadow-md">
        <OutlineButton onClick={backNavigate}>Back</OutlineButton>
      </div>
    </div>
  );
};
